/* 🤖 this file was generated by svg-to-ts */
export const matIconFiberNew: {
  name: 'fiber-new';
  data: string;
} = {
  name: 'fiber-new',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.25 12.5 4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2V9H7.25zM9.5 15h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5V9h-4zm9.75-6v4.5h-1.12V9.99h-1.25v3.52h-1.13V9H14.5v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h-1.25z"/></svg>`
};
